import {
  Button,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  Input,
  VStack,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';

const CompanyDetails = ({ next, back }) => {
  const { register, handleSubmit } = useForm();

  const onSubmit = (data) => {
    next(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <VStack spacing={4} align="stretch">
        <Grid templateColumns="repeat(2, 1fr)" gap={4}>
          <FormControl>
            <FormLabel>Company Name</FormLabel>
            <Input {...register('companyName')} />
          </FormControl>

          <FormControl>
            <FormLabel>Contact Person</FormLabel>
            <Input {...register('contactPerson')} />
          </FormControl>
        </Grid>

        <Grid templateColumns="repeat(2, 1fr)" gap={4}>
          <FormControl>
            <FormLabel>Email</FormLabel>
            <Input type="email" {...register('email')} />
          </FormControl>

          <FormControl>
            <FormLabel>Mobile</FormLabel>
            <Input {...register('mobile')} />
          </FormControl>
        </Grid>

        <Grid templateColumns="repeat(2, 1fr)" gap={4}>
          <Button onClick={back}>Back</Button>
          <Button type="submit" colorScheme="blue">
            Continue
          </Button>
        </Grid>
      </VStack>
    </form>
  );
};

export default CompanyDetails;
